/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   getQueryBuildingMaxPrice
 */

import { MAX_FILTER_PRICE } from '@zcode-ui/filters'
import type { Filters } from '@zcode/state-type'
import { isNumber } from '@zcode/utils'

export const getQueryBuildingMaxPrice = ({
  filters,
  price,
}: {
  filters: Partial<Filters> | undefined
  price: number | undefined
}) => {
  const filtersMaxPriceIsValid =
    filters &&
    isNumber(filters.maxPrice) &&
    (filters.maxPrice !== MAX_FILTER_PRICE || filters.customMaxPrice)

  if (filtersMaxPriceIsValid) {
    return filters.maxPrice
  } else if (isNumber(price)) {
    return price
  }

  return null
}
